import { contactSchema } from '@contact/types/contact';
import { duplicatedContactGroupSchema } from '@src/types/duplicateContacts';
import { z } from 'zod';

export const contactsUniquenessPayload = z.object({
  emails: z.string().array(),
});

export const contactsUniquenessResponseSchema = z.object({
  rejectedEmails: z.string().array(),
});

export const contactsTopicsResponseSchema = z.object({
  topics: z.string().array(),
});

export const createContactPayloadSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  smartGroupIds: z.number().array(),
});

export const createContactResponseSchema = contactSchema.extend({
  duplicatedContacts: duplicatedContactGroupSchema.array().optional(),
});

export const existingContactsPayloadSchema = z.object({
  sourceUids: z.string().array(),
});

export const existingContactsResponseSchema = z.record(
  z.string(),
  z.object({
    id: z.number(),
    smartGroupIds: z.number().array(),
  }),
);

export type ContactsUniquenessPayload = z.infer<typeof contactsUniquenessPayload>;
export type ContactsUniquenessResponse = z.infer<typeof contactsUniquenessResponseSchema>;
export type ContactsTopicsResponse = z.infer<typeof contactsTopicsResponseSchema>;
export type CreateContactPayload = z.infer<typeof createContactPayloadSchema>;
export type CreateContactResponse = z.infer<typeof createContactResponseSchema>;
export type ExistingContactsPayload = z.infer<typeof existingContactsPayloadSchema>;
export type ExistingContacts = z.infer<typeof existingContactsResponseSchema>;
